import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";

import {
  Box, Typography, Card, CardContent, Grid, TextField, Button, Stack, Chip, Avatar,
  Dialog, DialogTitle, DialogContent, IconButton, Tabs, Tab, Table, TableBody, TableCell, TableHead, TableRow
} from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import DoneIcon from '@mui/icons-material/Done';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import TopNav from './Navbar';
import LeftNavbar from './LeftNav';
import Breadcrumb from './BreadCrump';
import NumbersIcon from "@mui/icons-material/Numbers";
import EventIcon from "@mui/icons-material/Event";
import SchoolIcon from "@mui/icons-material/School";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LinkIcon from "@mui/icons-material/Link";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const getStatusChip = (status) => {
  switch (status) {
    case 'SUCCESS': return <Chip icon={<DoneIcon />} label="Success" color="success" size="small" />;
    case 'PENDING': return <Chip icon={<PendingIcon />} label="Pending" color="warning" size="small" />;
    case 'FAILURE': return <Chip icon={<CancelIcon />} label="Failed" color="error" size="small" />;
    default: return <Chip label={status || 'Unknown'} size="small" />;
  }
};

const PaymentRegister = () => {
  const token = localStorage.getItem('token');
  const [user, setUser] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [formData, setFormData] = useState({ amount: '', email: '', phone: '', name: '' });
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [orderId, setOrderId] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const iframeRef = useRef(null);
  const location = useLocation();
  const { courseId } = location.state || {}; // 👈 safely extract courseId
  const navigate = useNavigate();

  // Fetch user
  useEffect(() => {
    if (!token) return;
    fetch('http://196.216.9.34:5020/api/users/me', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(setUser);
  }, [token]);

  // Fetch transactions
  useEffect(() => {
    if (!user) return;
    fetch(`http://196.216.9.34:5050/api/transactions/${user.id}`)
      .then(res => res.json())
      .then(setTransactions)
      .catch(console.error);
  }, [tabValue, user]);

  const handleChangeForm = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setResponse(null);
    try {
      const res = await fetch('http://196.216.9.34:5050/api/register-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, amount: Number(formData.amount), userId: user.id, courseId: courseId }) // replace courseId
      });
      const data = await res.json();
      setResponse(data);
      if (data.formUrl) { setPaymentUrl(data.formUrl); setOrderId(data.orderId); setOpenModal(true); }
    } catch (err) {
      setResponse({ error: err.message });
    } finally { setLoading(false); }
  };

   // Poll iframe for completion
   useEffect(() => {
    const interval = setInterval(async () => {
      if (!iframeRef.current) return;
      try {
        const iframeUrl = iframeRef.current.contentWindow.location.href;
        if (iframeUrl.includes("http://196.216.9.34:3003/payments")) {
          setOpenModal(false);
          clearInterval(interval);

          if (orderId) {
            const statusRes = await fetch(`http://196.216.9.34:5050/api/payment-status/${orderId}`);
            const statusData = await statusRes.json();
            setResponse(prev => ({ ...prev, finalStatus: statusData.status }));
           
            // ✅ If payment successful → Enroll student

             
              fetch(`http://196.216.9.34:5020/api/courses/${courseId}/enroll`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
              })
                .then(async res => {
                  const data = await res.json();
                  if (res.ok) {
                    alert(data.message || "Enrolled successfully");
                    // refresh user info
                    await fetch("http://196.216.9.34:5020/api/users/me", {
                      headers: { Authorization: `Bearer ${token}` },
                    })
                      .then(res => res.json())
                      .then(setUser);

                    // ✅ Redirect to icards page
                    navigate("/icard");
                  } else {
                    alert(data.message || "Error enrolling");
                  }
                })
                .catch(() => alert("Network error while enrolling"));
            
          }
        }
      } catch (e) {}
    }, 2000);
    return () => clearInterval(interval);
  }, [orderId, token, formData.courseId, navigate]);

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Payments" />
          <Typography variant="h4" sx={{ mb: 4, color: '#ff6600' }}><PaymentIcon /> Payments</Typography>

          <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)} sx={{ mb: 3 }}>
            <Tab label="Register Payment" />
            <Tab label="Previous Transactions" />
          </Tabs>

          {tabValue === 0 && (
            <Card sx={{ mb: 4 }}>
              <CardContent>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    {['amount', 'email', 'phone', 'name'].map(field => (
                      <Grid item xs={12} md={6} key={field}>
                        <TextField
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                          name={field}
                          value={formData[field]}
                          onChange={handleChangeForm}
                          fullWidth required
                          type={field === 'amount' ? 'number' : 'text'}
                        />
                      </Grid>
                    ))}
                    <Grid item xs={12}>
                      <Button type="submit" variant="contained" disabled={loading}>
                        {loading ? 'Processing...' : 'Register Payment'}
                      </Button>
                    </Grid>
                  </Grid>
                </form>

                {response && <CardContent>
                  <Stack spacing={1}>
                    {Object.entries(response).map(([k, v]) => (
                      <Stack key={k} direction="row" alignItems="center" spacing={1}>
                        <Avatar sx={{ bgcolor: '#ff6600', width: 24, height: 24 }}>{k[0].toUpperCase()}</Avatar>
                        <Typography variant="body2"><strong>{k}:</strong> {v}</Typography>
                        {k.toLowerCase().includes('status') && getStatusChip(v)}
                      </Stack>
                    ))}
                  </Stack>
                </CardContent>}

                <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="md">
                  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Complete Payment
                    <IconButton onClick={() => setOpenModal(false)}><CloseIcon /></IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ height: '80vh', p: 0 }}>
                    <iframe ref={iframeRef} src={paymentUrl} width="100%" height="100%" style={{ border: 'none' }} />
                  </DialogContent>
                </Dialog>
              </CardContent>
            </Card>
          )}

          {tabValue === 1 && (
            <Card>
              <CardContent>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>
                        <NumbersIcon sx={{ color: "#1976d2", mr: 1, verticalAlign: "middle" }} />
                        <strong>ID</strong>
                      </TableCell>
                      <TableCell>
                        <EventIcon sx={{ color: "#0288d1", mr: 1, verticalAlign: "middle" }} />
                        <strong>Date</strong>
                      </TableCell>
                      <TableCell>
                        <SchoolIcon sx={{ color: "#7b1fa2", mr: 1, verticalAlign: "middle" }} />
                        <strong>Course</strong>
                      </TableCell>
                      <TableCell>
                        <ReceiptIcon sx={{ color: "#ef6c00", mr: 1, verticalAlign: "middle" }} />
                        <strong>Order ID</strong>
                      </TableCell>
                      <TableCell>
                        <LinkIcon sx={{ color: "#2e7d32", mr: 1, verticalAlign: "middle" }} />
                        <strong>Form URL</strong>
                      </TableCell>
                      <TableCell>
                        <PaymentIcon sx={{ color: "#6a1b9a", mr: 1, verticalAlign: "middle" }} />
                        <strong>Method</strong>
                      </TableCell>
                      <TableCell>
                        <MonetizationOnIcon sx={{ color: "#d32f2f", mr: 1, verticalAlign: "middle" }} />
                        <strong>Amount (k)</strong>
                      </TableCell>
                      <TableCell>
                        <CheckCircleIcon sx={{ color: "#388e3c", mr: 1, verticalAlign: "middle" }} />
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions.map(txn => (
                      <TableRow key={txn.id}>
                        <TableCell>{txn.id}</TableCell>
                        <TableCell>{txn.txn_date}</TableCell>
                        <TableCell>{txn.course_id}</TableCell>
                        <TableCell>{txn.order_id}</TableCell>
                        <TableCell>{txn.form_url ? <a href={txn.form_url} target="_blank" rel="noopener noreferrer">View</a> : '-'}</TableCell>
                        <TableCell>{txn.method}</TableCell>
                        <TableCell>{txn.amount_k}</TableCell>
                        <TableCell>{getStatusChip(txn.status)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          )}

        </Box>
      </Box>
    </Box>
  );
};

export default PaymentRegister;
